__turbopack_context__.v({
  "label": "BondScreenerViewNameModal-module-scss-module__WgWhYG__label",
  "modal": "BondScreenerViewNameModal-module-scss-module__WgWhYG__modal",
});
